import { render } from "./ClientDialog.vue?vue&type=template&id=779e05ba&scoped=true"
import script from "./ClientDialog.vue?vue&type=script&lang=js"
export * from "./ClientDialog.vue?vue&type=script&lang=js"

import "./ClientDialog.vue?vue&type=style&index=0&id=779e05ba&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-779e05ba"]])

export default __exports__